import LogoUrl from "@/components/brand/logo";
import { Button } from "@/components/ui/button";

export default function AppShell({
  children,
  experienceMode,
  onToggleExperience,
  theme,
  onToggleTheme,
}) {
  return (
    <div
      data-testid="app-shell"
      className="min-h-screen bg-[radial-gradient(60%_60%_at_20%_15%,rgba(124,58,237,0.16),transparent),radial-gradient(55%_55%_at_80%_25%,rgba(20,184,166,0.14),transparent),radial-gradient(45%_45%_at_55%_80%,rgba(244,114,182,0.12),transparent)]"
    >
      <header
        data-testid="app-header"
        className="sticky top-0 z-20 border-b border-border/50 bg-background/35 backdrop-blur supports-[backdrop-filter]:bg-background/20"
      >
        <div className="mx-auto max-w-7xl px-4 sm:px-6 py-4 flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-5">
          <div className="flex items-center gap-4 min-w-0">
            <div
              data-testid="brand-mark"
              className="h-14 w-14 sm:h-20 sm:w-20 lg:h-24 lg:w-24 rounded-3xl bg-background/20 border border-border/40 flex items-center justify-center overflow-hidden shrink-0"
            >
              <img
                data-testid="brand-logo"
                src={LogoUrl}
                alt="XtoInfiniti logo"
                className="h-11 w-11 sm:h-16 sm:w-16 lg:h-20 lg:w-20 object-contain rounded-2xl"
              />
            </div>
            <div className="leading-tight min-w-0">
              <div
                data-testid="brand-name"
                className="text-3xl sm:text-4xl lg:text-6xl font-bold tracking-tight truncate"
              >
                XtoInfiniti
              </div>
              <div
                data-testid="brand-mode"
                className="mt-1 text-sm sm:text-base text-muted-foreground"
              >
                Removing context limits from intelligence.
              </div>
            </div>
          </div>

          <div className="w-full sm:w-auto sm:ml-auto flex flex-col sm:flex-row items-stretch sm:items-center gap-2">
            {onToggleExperience ? (
              <Button
                data-testid="experience-mode-toggle-button"
                variant={experienceMode ? "default" : "outline"}
                onClick={onToggleExperience}
                className="rounded-full w-full sm:w-auto"
              >
                {experienceMode ? "Exit Experience Mode" : "Experience Mode"}
              </Button>
            ) : null}
            {onToggleTheme ? (
              <Button
                data-testid="theme-toggle-button"
                variant="outline"
                onClick={onToggleTheme}
                className="rounded-full w-full sm:w-auto"
              >
                {theme === "dark" ? "Light Mode" : "Dark Mode"}
              </Button>
            ) : null}
          </div>
        </div>
      </header>

      <main data-testid="app-main">{children}</main>
    </div>
  );
}
